import styled from "styled-components";

import { colors } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

const OffCanvasTrayBody = styled.div`
  padding: 25px 40px;
  flex: 1;
  background-color: ${colors.white};
  ${breakpoints.smDown} {
    padding: 20px 15px;
  }
`;

export default OffCanvasTrayBody;
